module.exports = __webpack_public_path__ + "img/know-1.cf00efc4.jpg";